import type { FC, ReactNode } from 'react';
import { Box } from '@gonfalon/observability-ui/components/Box';

export interface MessageWrapperProps {
  children: ReactNode;
  cssClass?: string;
}

/**
 * Bordered card for user-submitted messages. Intentionally narrow in scope —
 * assistant text, plan-mode messages, and tool-call accordions render plain
 * (no bubble). Inter-message spacing is owned by the caller's wrapper so the
 * copy affordance can sit just below the card.
 */
export const MessageWrapper: FC<MessageWrapperProps> = ({ children, cssClass }) => (
  <Box
    backgroundColor="default"
    border="divider"
    borderRadius="8"
    padding="8"
    cssClass={cssClass}
    style={{ fontSize: 13 }}
  >
    {children}
  </Box>
);
